__turbopack_context__.v({
  "className": "X4HdpG_className",
  "variable": "X4HdpG_variable",
});
